module.exports = __webpack_public_path__ + "static/media/newLaunches.ad896009.webp";